import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  fetchEmailsList,
  fetchEmailDetailsById,
  updateEmail,
} from "../../apis/outlookService";

import type { MailboxKey } from "../../utils/types/email";
import type { RootState } from "../store"; // Import RootState

type FetchEmailByIdArg =
  | string
  | {
      id: string;
      mailbox?: MailboxKey;
    };

export const fetchEmails = createAsyncThunk(
  "emails/fetchList",
  async (
    params: { folderId: string; top?: number; filter?: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState() as RootState;
      const mailbox = state.emails.currentMailbox;
      const emails = await fetchEmailsList({
        folderId: params.folderId,
        top: params.top || 50,
        filter: params.filter,
        mailbox,
      });
      return emails;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch emails"
      );
    }
  }
);

export const fetchEmailById = createAsyncThunk(
  "emails/fetchById",
  async (arg: FetchEmailByIdArg, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const id = typeof arg === "string" ? arg : arg.id;
      const mailbox =
        typeof arg === "string"
          ? state.emails.currentMailbox
          : arg.mailbox ?? state.emails.currentMailbox;
      const emailDetails = await fetchEmailDetailsById(id, mailbox);
      return emailDetails;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch email details"
      );
    }
  }
);

// --- NEW THUNK ---
export const toggleEmailFlag = createAsyncThunk(
  "emails/toggleFlag",
  async (emailId: string, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const mailbox = state.emails.currentMailbox;
      const email = state.emails.selectedEmailDetails;

      if (!email || email.id !== emailId) {
        throw new Error(
          "Cannot toggle flag: Email not selected or ID mismatch."
        );
      }

      // Assuming your backend has a `flagged` property to patch
      const updatedEmail = await updateEmail(emailId, {
        flagged: !email.flagged,
      }, mailbox);
      return updatedEmail;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to toggle flag");
    }
  }
);
